import { render, staticRenderFns } from "./MemorialCardView.vue?vue&type=template&id=827d4a66&"
import script from "./MemorialCardView.vue?vue&type=script&lang=js&"
export * from "./MemorialCardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports